export interface IComplexToDatesModel {
  start: Date | null
  end: Date | null
}

export class ComplexToDatesModel {
  public start: Date | null = null
  public end: Date | null = null

  constructor(model?: IComplexToDatesModel) {
    if (model) {
      Object.assign(this as Object, model)
    }
  }
}
